import { t } from '@/i18n'
import type { Movement } from '@/types'

import { EmptySeparator, InfoItem, Label, Section } from './components'

function movementTypeItem(movement: Movement) {
  if (movement.movementType === 'payOut') {
    return new InfoItem(t('movement.out'), movement.amount, {
      valueType: 'currency'
    })
  }
  return new InfoItem(t('movement.in'), movement.amount, {
    valueType: 'currency'
  })
}

function payInPayOut(
  movement: Movement & {
    employee?: string
    date: Date
  }
) {
  return [
    new Section(t('movement.movement')),
    new Label(movement.date, {
      valueType: 'date',
      style: 'bold 16px'
    }),
    new EmptySeparator(),
    new InfoItem(t('movement.employee'), movement.employee),
    movementTypeItem(movement),
    new InfoItem(t('movement.detail'), movement.detail)
  ]
}

export default payInPayOut
